// Client for the visibility tracker.
//
// Read-only: nothing here asks Amazon for anything. Collection lives in Search
// Terms, and this feature reads what that one has already stored.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/visibility`;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class NotConnectedError extends Error {
  constructor(message) {
    super(message || 'Amazon account not connected');
    this.notConnected = true;
  }
}

const call = async (url, options) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.connected === false) throw new NotConnectedError(data.error);
  if (!res.ok || !data.success) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
};

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v);
  });
  return search.toString();
};

// One card per sub-feature.
export const getOverview = (token, params) =>
  call(`${BASE}/overview?${query(params)}`, { headers: headers(token) });

// SF2 sessions and SF3 page views.
export const getTraffic = (token, params) =>
  call(`${BASE}/traffic?${query(params)}`, { headers: headers(token) });

// SF1 keyword performance and SF4 impression share, for one ASIN.
export const getKeywords = (token, params) =>
  call(`${BASE}/keywords?${query(params)}`, { headers: headers(token) });

// SF5 search visibility score.
// SF2 and SF3's per-ASIN graph — one product's traffic across windows.
export const getProductTraffic = (token, params) =>
  call(`${BASE}/product-traffic?${query(params)}`, { headers: headers(token) });

export const getScores = (token, params) =>
  call(`${BASE}/scores?${query(params)}`, { headers: headers(token) });

// The product picker uses the same catalogue endpoint as everywhere else.
export const getCatalogue = async (token) => {
  const res = await fetch(`${API_URL}/oauth_amazon/amazon/catalogue`, { headers: headers(token) });
  if (!res.ok) throw new Error(`Failed to load catalogue (${res.status})`);
  return (await res.json()).products || [];
};
